<template>
  <v-row v-if="webinarInPast === false && webinarInTwoWeeks===true" align="center" class="mt-2" justify="center">
    <v-col
      class="text-h4 font-weight-light text-center text-lg-left"
      cols="12"
      lg="8"
    >
      <h4 class="font-weight-medium">Gratis Webinar: {{ webinar.name }}</h4>
      <p class="text-subtitle-1 pt-2">
        {{ webinarInPast ? "gegeven op" : "op" }} {{ start_date }}
      </p>
    </v-col>
    <v-col
      class="text-h4 font-weight-light text-center text-lg-left"
      cols="12"
      lg="4"
    >
      <v-btn
        :block="$vuetify.display.lgAndUp"
        :href="webinar.link"
        class="mx-lg-5"
        size="x-large"
      >
        {{ webinarInPast ? "terugkijken" : "Aanmelden" }}
      </v-btn>
    </v-col>
  </v-row>
</template>

<script lang="ts" setup>
import type { WebinarRo } from "@backend/modules/webinar/dto/webinar-ro";
import dayjs from "dayjs";
import { useWebinarStore } from "@/store/webinar/webinar.store";
import { onMounted, ref } from "vue";
import { formatTime } from "@/common/time.common";

const webinarStore = useWebinarStore();

const webinar = ref<WebinarRo>();
const start_date = ref("");
const webinarInPast = ref(false);
const webinarInTwoWeeks = ref(false);

onMounted(async () => {
  webinar.value = await webinarStore.fetchWebinar();
  if (!webinar.value) return;
  start_date.value = formatTime(webinar.value.start_date, {
    day: "numeric",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
  webinarInPast.value = dayjs(webinar.value?.end_date).isBefore(dayjs());
  webinarInTwoWeeks.value = dayjs(webinar.value?.end_date).isBefore(dayjs().add(14, 'day'));
});
</script>
